import { MERCHANT_ADMIN_MEMBER_LIST } from "constants/action-types";
import type { IAction, IFetchParams } from "epics/base-epic";
import { stringify } from "querystring";
import { Dispatch } from "react";
import type { IStore } from "reducers";
import siteConfig from "site-config";

const MEMBERS_PAGE_SIZE = 20;

export type FetchMembersOptions = {
    search_query?: string;
    order_by_field?: string;
    order_by_desc?: boolean;
};

export const fetchMembers =
    (merchantId: string, adminTeamId: string, { search_query, order_by_field, order_by_desc }: FetchMembersOptions) =>
    (dispatch: Dispatch<IAction<IFetchParams>>, getState: () => IStore) => {
        const { next_page_token } = getState().merchantAdminMemberList.members.payload;
        const query = stringify({
            page_size: MEMBERS_PAGE_SIZE,
            ...(next_page_token && { page_token: next_page_token }),
        });

        dispatch({
            type: MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.FETCH.START,
            payload: {
                method: "GET",
                url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/teams/${adminTeamId}/members?${query}`,
            },
        });
    };

export const resetMembers = () => ({ type: MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.RESET });

export const setErrorMessage = (message: string) => ({
    type: MERCHANT_ADMIN_MEMBER_LIST.ERROR_MESSAGE.SET,
    payload: message,
});
